import React from 'react';
import { Loader, colors } from '@plugsurfing/elemental-ui';

export const LoadingOverlay = React.memo(() => (
  <div className="loader-overlay">
    <Loader size={128} color={colors.cushyBlue} />
  </div>
));
